"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _select = _interopRequireDefault(require("../select"));
var _treeUtil = require("../treeUtil");
var _checkboxCustom = _interopRequireDefault(require("./components/checkboxCustom"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Get all Leaf node id
 * @param {Array}  tree             The tree that you want to get leaf node id
 * @return {Array}                  All leaf node result
 */
var getAllLeafNodeId = function getAllLeafNodeId(tree) {
  var leafNodes = [];
  if (!tree) {
    return [];
  }
  for (var i = 0; i < tree.length; i += 1) {
    var node = tree[i];
    if (node.checked && (_lodash.default.isEmpty(node.children) || _lodash.default.every(node.children, ['checked', false]))) {
      leafNodes = leafNodes.concat(node.id);
    }
  }
  return leafNodes;
};

/**
 * Get all Leaf string nodeId
 * @param {Array}  tree             The tree that you want to get leaf nodeid typeof string
 * @return {Array}                  All leaf node result
 */
var getAllLeafStringNodeId = function getAllLeafStringNodeId(tree) {
  var leafStringNodes = [];
  if (!tree) {
    return [];
  }
  for (var i = 0; i < tree.length; i += 1) {
    var node = tree[i];
    if (node.checked && (_lodash.default.isEmpty(node.children) || _lodash.default.every(node.children, ['checked', false]))) {
      leafStringNodes = leafStringNodes.concat(node.nodeId);
    }
  }
  return leafStringNodes;
};
var OSSFields = function OSSFields(props) {
  var checkedOption = props.checkedOption,
    levels = props.levels,
    multi = props.multi,
    t = props.t;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedNodeList = _useState2[0],
    setSelectedNodeList = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    nodeTree = _useState4[0],
    setNodeTree = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    nodeList = _useState6[0],
    setNodeList = _useState6[1];

  /**
   * Initial organizational structure
   * @param {Array} initialSelectedNodeList The node list selected initial
   */
  var initialOSS = function initialOSS(initialSelectedNodeList) {
    if (_lodash.default.isNil(initialSelectedNodeList.length)) {
      return;
    }
    var tree = (0, _treeUtil.createTree)(props.nodeList);
    var initialNodeIds = initialSelectedNodeList.map(function (node) {
      return node.nodeId;
    });
    var processTree = function processTree(data) {
      var _loop = function _loop() {
        var node = data[i];
        if (initialNodeIds.some(function (n) {
          return n === node.nodeId;
        })) {
          node.checked = true;
          (0, _treeUtil.updateParents)(tree, node, true);
        }
        if (node.children) {
          processTree(node.children);
        }
      };
      for (var i = 0; i < data.length; i += 1) {
        _loop();
      }
    };
    if (initialNodeIds.length > 0) {
      processTree(tree);
    }
    var updatedNodeList = (0, _treeUtil.flatten)(tree);
    setNodeTree(tree);
    setNodeList(updatedNodeList);
    setSelectedNodeList(updatedNodeList.filter(function (node) {
      return node.checked;
    }));
  };
  (0, _react.useEffect)(function () {
    initialOSS(props.selectedNodeList);
  }, []);
  (0, _react.useEffect)(function () {
    initialOSS(props.selectedNodeList);
  }, [props.selectedNodeList]);

  /**
   * Get selected node by level id
   * @param {String} levelId       The level id of the field you are selected
   * @param {Array} selectedNodes  The all node value of the multi select field you are selected
   * @return {Array}               All node value you are adding/remove on the field
   */
  var getSelectedNodesByLevelId = function getSelectedNodesByLevelId(levelId, selectedNodes) {
    var selectedNodeListSameLevel = _lodash.default.filter(selectedNodeList, ['levelId', levelId]);
    selectedNodeListSameLevel = _lodash.default.map(selectedNodeListSameLevel, function (e) {
      return {
        id: e.id
      };
    });
    // if the selectedNodeListSameLevel is empty that mean there are no node selected before
    // so we return the selectedNode is received by the multi select component
    if (_lodash.default.isEmpty(selectedNodeListSameLevel)) {
      return selectedNodes;
    }
    var nodeAdding = _lodash.default.differenceBy(selectedNodeListSameLevel, selectedNodes, 'id');
    var nodeRemove = _lodash.default.differenceBy(selectedNodes, selectedNodeListSameLevel, 'id');
    return nodeAdding.concat(nodeRemove);
  };

  /**
   * Get the all node checked
   * @param {Object} clickedNode The node is selected
   * @return {Object}            The checked node list
   */
  var getCheckedUpdatedNodeList = function getCheckedUpdatedNodeList(clickedNode) {
    var tree = nodeTree.slice(0);
    var processTree = function processTree(data) {
      if (!data) {
        return false;
      }
      for (var i = 0; i < data.length; i += 1) {
        var node = data[i];
        if (clickedNode.nodeId === node.nodeId) {
          if (node.checked === true) {
            node.checked = false;
            (0, _treeUtil.updateChildren)(node, false);
          } else {
            node.checked = true;
            (0, _treeUtil.updateParents)(tree, node, true);
          }
        }
        if (node.children) {
          processTree(node.children);
        }
      }
      return data;
    };
    processTree(tree);
    var updatedNodeList = (0, _treeUtil.flatten)(tree);
    var checkedUpdatedNodeList = updatedNodeList.filter(function (n) {
      return n.checked;
    });
    setNodeTree(tree);
    return checkedUpdatedNodeList;
  };

  /**
   * On Change OSS
   * @param {Array|Object} value      The selected value of the OSS field
   * @param {String} levelId The level id of the OSS field
   */
  var _onChange = function onChange(value, levelId) {
    // For single selector, do not change value if it was selected already
    if (!multi && _lodash.default.find(selectedNodeList, {
      id: value.value
    })) {
      return;
    }
    var data = multi ? value : [value];
    var selectedNodeMapIds = _lodash.default.map(data, function (node) {
      return {
        id: node.value
      };
    });
    var selectedNodes = getSelectedNodesByLevelId(levelId, selectedNodeMapIds);
    selectedNodes = _lodash.default.intersectionBy(nodeList, selectedNodes, 'id');
    var checkedUpdatedNodeList = {};
    _lodash.default.forEach(selectedNodes, function (item) {
      checkedUpdatedNodeList = getCheckedUpdatedNodeList(item);
    });
    var leafNodes = getAllLeafNodeId(checkedUpdatedNodeList);
    var leafStringNodeId = getAllLeafStringNodeId(checkedUpdatedNodeList);
    props.onChange({
      leafNodes: leafNodes,
      selectedNodeList: checkedUpdatedNodeList,
      leafStringNodeId: leafStringNodeId
    });
  };
  var handleCheck = function handleCheck(statusOption, valueOption, levelId, selectedValue) {
    if (multi) {
      var newStatusChecked = statusOption ? [].concat((0, _toConsumableArray2.default)(selectedValue), [valueOption]) : selectedValue.filter(function (stt) {
        return stt.value !== valueOption.value;
      });
      _onChange(newStatusChecked, levelId);
    } else {
      _onChange(valueOption, levelId);
    }
  };

  /**
   * Get list for each OSS field
   * @param {Object} selectedLevel The level of the OSS field
   * @return {Array}               The options of the OSS field
   */
  var getOptions = function getOptions(selectedLevel) {
    var visibleNodes = [];
    if (selectedNodeList.length > 0) {
      var tree = nodeTree.slice(0);
      visibleNodes = (0, _treeUtil.getNodesCoDependent)(levels, selectedLevel, nodeList, tree);
    }
    return selectedNodeList.length > 0 && levels.length !== 1 ? visibleNodes : nodeList.filter(function (node) {
      return node.levelId === selectedLevel;
    });
  };

  /**
   * Render Field
   * @param {String} name    The name of the field
   * @param {String} levelId The level id
   * @return {Element}       React Element
   */
  var renderField = function renderField(name, levelId) {
    var selectedNodeListSameLevel = _lodash.default.filter(selectedNodeList, ['levelId', levelId]);
    var options = getOptions(levelId);
    var placeholder = "".concat(t('Select'), " ").concat(name);
    // format data that support fit the format of Select component
    var selectedValue = _lodash.default.map(selectedNodeListSameLevel, function (node) {
      return {
        value: node.id,
        label: node.nodeName
      };
    });
    var statusCheckedSelected = _lodash.default.map(selectedNodeListSameLevel, function (node) {
      return node.id;
    });
    options = _lodash.default.map(options, function (o) {
      return {
        value: o.id,
        label: o.nodeName
      };
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "field",
      key: levelId
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "field-label"
    }, name), checkedOption === 'checkbox' ? /*#__PURE__*/_react.default.createElement(_select.default, {
      className: "".concat(name, "-oss"),
      options: options,
      placeholder: placeholder,
      value: selectedValue,
      searchable: true,
      multi: multi,
      name: name,
      ReactComponents: {
        Option: _checkboxCustom.default,
        onChange: function onChange(statusOption, valueOption) {
          return handleCheck(statusOption, valueOption, levelId, selectedValue);
        },
        statusChecked: statusCheckedSelected
      },
      onChange: function onChange(value) {
        return _onChange(value, levelId);
      }
    }) : /*#__PURE__*/_react.default.createElement(_select.default, {
      placeholder: placeholder,
      className: "".concat(name, "-oss"),
      searchable: true,
      multi: multi,
      name: name,
      value: selectedValue,
      options: options,
      onChange: function onChange(value) {
        return _onChange(value, levelId);
      }
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "oss-fields"
  }, levels.map(function (o) {
    return renderField(t(o.levelName.trim()), o.levelId);
  }));
};
OSSFields.propTypes = {
  t: _propTypes.default.func,
  selectedNodeList: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  nodeList: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  onChange: _propTypes.default.func.isRequired,
  levels: _propTypes.default.arrayOf(_propTypes.default.shape({
    levelName: _propTypes.default.string,
    levelId: _propTypes.default.string,
    levelIndex: _propTypes.default.number
  })),
  multi: _propTypes.default.bool,
  checkedOption: _propTypes.default.string
};
OSSFields.defaultProps = {
  t: function t(x) {
    return x;
  },
  selectedNodeList: [],
  nodeList: [],
  levels: [],
  multi: false,
  checkedOption: ''
};
var _default = OSSFields;
exports.default = _default;